// extracted by mini-css-extract-plugin
module.exports = {"homeLogo":"reset-password_homeLogo__1Orw1"};